// extracted by mini-css-extract-plugin
export default {"container":"Yi-z","blurb":"Zi-z","links":"_i-z"};